<div *ngIf="data" id="marketedDrugContainer">
  <div class="heading">
    <span> Summary </span>
  </div>
  <div class="items-margin">
    <div id="revenue">
      <div class="sub-heading">
        <span>Revenue</span>
      </div>
      <div
        class="items"
        *ngFor="let item of data.marketed.forcast_data.actual_data"
      >
        <div class="letters">
          {{ item.period }} ({{ data.meta_data.currency
          }}{{ data.meta_data.magnitude }})
        </div>
        <div class="numbers">
          <span
            *ngIf="item.value_formatted"
            [ngClass]="{ 'cell-negative': item.value_formatted.includes('(') }"
          >
            {{ item.value_formatted }}
          </span>
        </div>
      </div>
      <div
        class="items"
        *ngFor="let item of data.marketed.forcast_data.estimated_data"
      >
        <div class="letters">
          {{ item.period }} ({{ data.meta_data.currency
          }}{{ data.meta_data.magnitude }})
        </div>
        <div class="numbers">
          <span
            *ngIf="item.value_formatted"
            [ngClass]="{ 'cell-negative': item.value_formatted.includes('(') }"
          >
            {{ item.value_formatted }}
          </span>
        </div>
      </div>
    </div>
    <!-- <nz-divider class="divider"></nz-divider> -->
    <div id="peakStats">
      <div class="sub-heading">
        <span>Peak Sales</span>
      </div>
      <div class="items">
        <div class="letters">
          <span> Peak year </span>
        </div>
        <div class="numbers">
          {{
            data.marketed.peak_year !== null &&
            data.marketed.peak_year !== undefined
              ? data.marketed.peak_year
              : "-"
          }}
        </div>
      </div>
      <div class="items">
        <div class="letters">
          <span>
            Peak sales (risk adjusted)({{ data.meta_data.currency
            }}{{ data.meta_data.magnitude }})
          </span>
          <span class="info-icon-class">
            <i
              nz-popover
              nzPopoverPlacement="right"
              nzPopoverContent="Peak revenue is calculated by taking the highest value among our consensus data within our forecast periods. If the first or the last observable period is the peak, then we do not list a peak value."
              nzPopoverTrigger="hover"
              class="info-icon"
              [nzPopoverOverlayStyle]="{ width: '261px' }"
            >
              <va-icon size="small" name="info-circle"></va-icon>
            </i>
          </span>
        </div>
        <div class="numbers">
          {{ data.marketed.peak_value_formatted }}
        </div>
      </div>
      <div class="items" hidden>
        <div class="letters">
          <span>
            Broker peaks (avg) ({{ data.meta_data.currency
            }}{{ data.meta_data.magnitude }})
          </span>

          <span class="info-class">
            <i
              nz-popover
              nzPopoverPlacement="right"
              nzPopoverContent="This is the calculated average of each broker's peak revenue estimate,  regardless of what year it falls in. This will provide a different peak value when brokers disagree on the peak year."
              nzPopoverTrigger="hover"
              class="info-icon"
              [nzPopoverOverlayStyle]="{ width: '261px' }"
            >
              <va-icon size="small" name="info-circle"></va-icon>
            </i>
          </span>
        </div>
        <div class="numbers">
          {{ data.marketed.analyst_avg_value_formatted }}
        </div>
      </div>
      <div class="items">
        <div class="letters">
          <span> 3 yrs after peak </span>
        </div>
        <div class="numbers">
          <span>{{
            data.marketed.three_year_after_data.value_change_formatted
          }}</span>
          <span
            *ngIf="
              data.marketed.three_year_after_data.percentage_change_formatted
            "
            [ngClass]="{
              'cell-negative':
                data.marketed.three_year_after_data.percentage_change_formatted.includes(
                  '('
                )
            }"
            >&nbsp;{{
              data.marketed.three_year_after_data.percentage_change_formatted.includes(
                "("
              )
                ? data.marketed.three_year_after_data
                    .percentage_change_formatted
                : "(" +
                  data.marketed.three_year_after_data
                    .percentage_change_formatted +
                  ")"
            }}</span
          >
        </div>
      </div>
    </div>
    <!-- <nz-divider class="divider"></nz-divider> -->
    <div id="keyDates">
      <div class="sub-heading">
        <span>Key Dates</span>
      </div>
      <div class="items">
        <div class="letters">
          <span> Approved </span>
        </div>
        <div class="numbers">
          {{
            data.marketed.approval_date !== null &&
            data.marketed.approval_date !== undefined
              ? (data.marketed.approval_date | date: "dd-MMM-yyyy")
              : "-"
          }}
        </div>
      </div>
      <div class="items">
        <div class="letters">
          <span> Patent expiry </span>
        </div>
        <div class="numbers">
          {{
            data.marketed.patent_expiry !== null &&
            data.marketed.patent_expiry !== undefined
              ? (data.marketed.patent_expiry | date: "dd-MMM-yyyy")
              : "-"
          }}
        </div>
      </div>
    </div>
  </div>
</div>
